import React from 'react';
import { SubjectIssuesSection } from '../../../features/issues/components/SubjectIssuesSection';

/**
 * Where this person stands on the issues being tracked. Hides itself when they
 * have no recorded position, or when the server has no issues module.
 */
export const StakeholderIssuesSection: React.FC<{ stakeholderId: string | undefined; className?: string }> = ({
  stakeholderId,
  className,
}) => <SubjectIssuesSection subjectType="stakeholder" subjectId={stakeholderId} className={className} />;

export default StakeholderIssuesSection;
